import React from 'react';
import { Link, graphql, StaticQuery } from 'gatsby';
import Img from 'gatsby-image';

import './mobile-header.scss';
import Dropdown from '../dropdown/dropdown';

export default ({ location }) => {
  const handleClick = () => {
    const body = document.getElementsByTagName('body')[0];

    if (body.classList.contains('mobile-header__open')) {
      body.classList.remove('mobile-header__open');
    } else {
      body.classList.add('mobile-header__open');
    }
  };

  return (
    <StaticQuery
      query={graphql`
        query MobileHeaderQuery {
          facebook: file(relativePath: { eq: "facebook-white.png" }) {
            childImageSharp {
              fixed(height: 28) {
                ...GatsbyImageSharpFixed
              }
            }
          }
          instagram: file(relativePath: { eq: "instagram-white.png" }) {
            childImageSharp {
              fixed(height: 28) {
                ...GatsbyImageSharpFixed
              }
            }
          }

          services: allContentfulService {
            edges {
              node {
                name
                slug
              }
            }
          }
        }
      `}
      render={data => (
        <div className="mobile-header">
          <nav role="navigation">
            <Link
              to="/"
              className={location.pathname === '/' ? 'active' : ''}
              onClick={handleClick}
            >
              <strong>Home</strong>
            </Link>
            <Link className={location.pathname.includes('servizio') ? 'active' : ''}>
              <Dropdown
                activatorText="Servizi e trattamenti"
                items={data.services.edges.map(edge => {
                  return {
                    name: edge.node.name,
                    link: `/servizio/${edge.node.slug}`,
                    onClick: handleClick,
                  };
                })}
              />
            </Link>
            <Link to="#dove-siamo" onClick={handleClick}>
              <strong>Dove siamo</strong>
            </Link>
            <Link
              to="/chi-siamo"
              className={location.pathname === '/chi-siamo' ? 'active' : ''}
              onClick={handleClick}
            >
              <strong>Chi siamo</strong>
            </Link>
            <Link to="#contatti" onClick={handleClick}>
              <strong>Contatti</strong>
            </Link>
          </nav>

          <div className="social">
            <a
              href="https://www.facebook.com/Spazio-536-studio-estetico--111873243707835/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-logo"
            >
              <Img fixed={data.facebook.childImageSharp.fixed}></Img>
            </a>
            <a
              href="https://www.instagram.com/spazio_536/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-logo"
            >
              <Img fixed={data.instagram.childImageSharp.fixed}></Img>
            </a>
          </div>
        </div>
      )}
    ></StaticQuery>
  );
};
